<div mat-dialog-content>
  
  <mat-form-field appearance="fill" >
    <mat-label>{{data.label}}</mat-label>
    <input type="number" matInput [(ngModel)]="data.amount">
  </mat-form-field>
</div>

<div mat-dialog-actions>
  <button class="simple-button" mat-button [mat-dialog-close]="-1">Cancel</button>
  <button class="simple-button" mat-button [mat-dialog-close]="data.amount" cdkFocusInitial>Create New {{data.label}}</button>
</div>
